import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteView } from '../../../../actions/security/View';

const DeleteViewButton = ({ viewId, dispatchDeleteView }) => {
  const [showModal, setShowModal] = React.useState(false);
  const onClickDelete = () => dispatchDeleteView({ viewId })
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (  
    <Fragment>
      <ConfirmationModal 
      show={showModal}
      onClickConfirm={onClickDelete}
      onClickCancel={closeModal}
    />
      <Button color="danger" onClick={openModal}>
        Eliminar
      </Button>  
    </Fragment>
  )
};

DeleteViewButton.propTypes = {
  viewId: PropTypes.number.isRequired,
  dispatchDeleteView: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteView: deleteView
};

export default connect(null, mapDispatchToProps)(DeleteViewButton);
